import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

import { useAuthContext } from '../../context/authContext';

/**
 * El panel del dueno, de una sola llamada al backend.
 *
 * Reemplaza a useMetricasNegocio para la parte de plata. Aquel traia el MRR,
 * que es el valor de los planes vigentes: un numero que casi no se mueve de
 * un dia a otro y que no distingue entre plata que entro este mes y plata que
 * entro en agosto. Por eso el panel se veia congelado.
 *
 * Esto trae la venta real de cada dia, que si se mueve y si se puede comparar.
 */
export default function useCeoMetrics() {
  const { token, baseUrl } = useAuthContext();

  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  const cargar = useCallback(() => {
    setError('');
    return axios.get(`${baseUrl}admin/analytics/ceo`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      // El API envuelve todo en {code, message, data}.
      .then((r) => setDatos(r.data?.data ?? r.data))
      .catch((e) => {
        const estado = e?.response?.status;
        setError(
          estado === 401 || estado === 403
            ? 'Tu sesión no tiene permiso para ver estas cifras.'
            : !e?.response
              ? 'No pudimos conectarnos con el servidor.'
              : 'El servidor no pudo calcular las cifras. Intenta de nuevo en unos minutos.'
        );
      })
      .finally(() => setCargando(false));
  }, [token, baseUrl]);

  useEffect(() => { cargar(); }, [cargar]);

  return { datos, cargando, error, recargar: cargar };
}
